import { createSelector } from 'reselect';

const systemSettingsSelector = (environmentDataStore, settingNames) => environmentDataStore?.items?.systemsettings?.value?.filter(systemSetting => settingNames.includes(systemSetting.casa_name))

export const getSystemSettingsSelector = createSelector(
    systemSettingsSelector,
    (systemSettings) => systemSettings
);

const b2cSettingSelector = (b2cSettings, settingNames) => {
    let settings = {}

    if (b2cSettings?.items) {
        settingNames.map(element => {
            settings[element] = b2cSettings.items[element]
        })
    }

    return settings
}

export const getB2cSettingsSelector = createSelector(
    b2cSettingSelector,
    (b2cSettings) => b2cSettings
);